exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".submitBtn[data-v-5e969706] {\n  text-align: '';\n  border-top: 0;\n  padding: '';\n  text-align: center;\n}\n[data-v-5e969706] .avatar-uploader-icon {\n  width: 1.041667rem;\n}\n[data-v-5e969706] .avatar-uploader .el-upload {\n  width: 1.145833rem;\n  height: 0.9375rem;\n}\n[data-v-5e969706] img {\n  width: 1.145833rem;\n  height: 0.9375rem;\n}", ""]);

// exports
